/**
 * Global ads kill switch.
 *
 * All ad placements (Google AdSense units AND the first-party NativePromo
 * fallback frames) are hidden while the site has ~zero traffic. Flip to
 * `true` to bring every placement back — and restore the AdSense loader
 * condition in public/index.html (see the comment there).
 */
export const ADS_ENABLED: boolean = false;
